"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var storage_1 = require("../../../utils/storage");
var utils_1 = require("../../../utils");
var constants_1 = require("./constants");
exports.withStyles = recompose_1.compose(recompose_1.getContext({ styles: PropTypes.object }), muiThemeable_1.default(), recompose_1.mapProps(function (_a) {
    var muiTheme = _a.muiTheme, styles = _a.styles, rest = __rest(_a, ["muiTheme", "styles"]);
    return (__assign({ styles: lodash_1.merge(styles, muiTheme.grid) }, rest));
}));
exports.cellStyle = function (styles, column) {
    return column.align
        ? { textAlign: column.align }
        : column.type === constants_1.ColumnType.TEXT || column.type === constants_1.ColumnType.TEXT_NUMBER
            ? styles.renderer.text
            : styles.renderer.other;
};
exports.cellAlign = function (styles, column) { return exports.cellStyle(styles, column).textAlign; };
exports.isSorted = function (_a, sort) {
    var field = _a.field;
    return sort === field;
};
exports.replace = function (array, oldValue, newValue) { return array.map(function (value) { return (value === oldValue ? newValue : value); }); };
var stateManagerChangedPropsChecker = function (props, nextProps, item) { return props[item] !== nextProps[item]; };
/**
 * Applies saved visibility and order to columns passed through props.
 *
 * @param {Array} columns Props columns
 * @param {Array} savedColumns Saved columns
 * @returns {Array} Sorted columns with set visibility
 */
var applySavedColumns = function (columns, savedColumns) {
    return savedColumns.map(function (savedColumn) {
        var column = lodash_1.find(columns, function (c) { return c.field === savedColumn.field && c.label === savedColumn.label; });
        return __assign({}, column, { visible: savedColumn.visible });
    });
};
/**
 * Loads settings from storage. @see setPersistenceProps for more detail.
 *
 * Loaded only if provided version and saved version is the same. Otherwise
 * empty object is returned.
 *
 * @param {*} name Name of the grid
 * @param {*} props Specified props of the grid
 * @returns {*} Override properties from storage
 */
var getPersistenceProps = function (name, props) {
    var columns = props.columns, version = props.version;
    var _a = storage_1.safeGet(name) || {}, savedColumns = _a.columns, savedVersion = _a.version, settings = __rest(_a, ["columns", "version"]);
    if (version === savedVersion) {
        var appliedColumns = savedColumns ? applySavedColumns(columns, savedColumns) : columns;
        return __assign({ columns: appliedColumns, defaultColumns: columns }, settings);
    }
    else {
        return {
            defaultColumns: columns,
        };
    }
};
/**
 * Saves grid settings to storage.
 *
 * Version, Page, Page Size, Sort, Order, Filters, Opened filters, dirty flag are saved as is.
 * Columns are saved as ordered array of field, label and visibility flag.
 *
 * @param {String} name Name of the grid
 * @param {*} props Specified props of the grid
 */
var setPersistenceProps = function (name, props) {
    var columns = props.columns;
    var savedColumns = columns.map(function (c) { return lodash_1.pick(c, ['field', 'label', 'visible']); });
    var settings = lodash_1.pick(props, [
        'version',
        'page',
        'pageSize',
        'sort',
        'order',
        'filters',
        'universalFilter',
        'openedFilters',
        'allowDeleted',
        'allowDeactivated',
        'active',
        'dirty',
    ]);
    storage_1.safePut(name, __assign({}, settings, { columns: savedColumns }));
};
/**
 * Resets the settings of the specified grid.
 *
 * @param {String} name Name of the grid
 */
var resetPersistenceProps = function (name) {
    if (!lodash_1.isEmpty(name)) {
        storage_1.remove(name);
    }
};
/**
 * Higher order component responsible for applying saved settings to grid.
 */
exports.persistencePropsLoader = recompose_1.branch(function (_a) {
    var name = _a.name, ignoreLocalStorage = _a.ignoreLocalStorage;
    return !ignoreLocalStorage && !lodash_1.isEmpty(name);
}, recompose_1.withProps(function (_a) {
    var name = _a.name, props = __rest(_a, ["name"]);
    return getPersistenceProps(name, props);
}));
var drag = function (array, dragIndex, dropIndex) {
    if (dragIndex === dropIndex)
        return array;
    var visibleOnly = array.filter(function (_a) {
        var visible = _a.visible;
        return visible !== false;
    });
    var dragIndexReal = lodash_1.findIndex(array, function (_a) {
        var field = _a.field;
        return field === lodash_1.get(visibleOnly, "[" + dragIndex + "].field");
    });
    var dropIndexReal = lodash_1.findIndex(array, function (_a) {
        var field = _a.field;
        return field === lodash_1.get(visibleOnly, "[" + dropIndex + "].field");
    });
    return dragIndexReal <= dropIndexReal
        ? __spread(array.slice(0, dropIndexReal + 1).filter(function (c) { return c !== array[dragIndexReal]; }), [
            array[dragIndexReal]
        ], array.slice(dropIndexReal + 1)) : __spread(array.slice(0, dropIndexReal + 1).filter(function (c) { return c !== array[dropIndexReal]; }), [
        array[dragIndexReal],
        array[dropIndexReal]
    ], array.slice(dropIndexReal + 1).filter(function (c) { return c !== array[dragIndexReal]; }));
};
exports.gridReducer = function (state, action) {
    switch (action.type) {
        case 'PAGE':
            return __assign({}, state, { page: action.payload, dirty: true });
        case 'PAGE_SIZE':
            return __assign({}, state, { pageSize: action.payload, page: 0, dirty: true });
        case 'SORT':
            return __assign({}, state, { sort: action.payload, dirty: true });
        case 'ORDER':
            return __assign({}, state, { order: action.payload, dirty: true });
        case 'FILTERS':
            return __assign({}, state, { filters: action.payload, dirty: true });
        case 'UNIVERSAL_FILTER':
            return __assign({}, state, { universalFilter: action.payload, dirty: true });
        case 'OPENED_FILTERS':
            return __assign({}, state, { openedFilters: !state.openedFilters, dirty: false });
        case 'OPEN_FILTERS':
            return __assign({}, state, { openedFilters: action.payload, dirty: false });
        case 'COLUMN_DIALOG':
            return __assign({}, state, { openedColumnsDialog: !state.openedColumnsDialog, dirty: false });
        case 'CHECK':
            return __assign({}, state, { checkedItems: action.payload, dirty: false });
        case 'GROUP':
            return __assign({}, state, { group: action.payload, openedGroups: [], dirty: true });
        case 'GROUP_OPENED':
            return __assign({}, state, { openedGroups: action.payload, dirty: true });
        case 'SHOW_DELETED':
            return __assign({}, state, { allowDeleted: action.payload, dirty: true });
        case 'SHOW_DEACTIVATED':
            return __assign({}, state, { allowDeactivated: action.payload, dirty: true });
        case 'COLUMNS':
            return __assign({}, state, { columns: action.payload, dirty: true });
        case 'MERGE_STATE':
            return __assign({}, state, action.payload);
        case 'MOVE_COLUMN': {
            var _a = action.payload, dragIndex = _a.dragIndex, dropIndex = _a.dropIndex;
            return __assign({}, state, { columns: drag(state.columns, dragIndex, dropIndex), dirty: true });
        }
        case 'DIRTY':
            return __assign({}, state, { dirty: true }, action.payload);
        default:
            return state;
    }
};
exports.actionHandler = lodash_1.curry(function (actionType, _a, value) {
    var dispatch = _a.dispatch, name = _a.name, state = _a.state;
    var action = utils_1.createAction(actionType, value);
    dispatch(action);
    if (!lodash_1.isEmpty(name)) {
        var nextPersistanceState = exports.gridReducer(state, action);
        setPersistenceProps(name, nextPersistanceState);
    }
});
exports.gridStateManager = recompose_1.compose(recompose_1.withReducer('state', 'dispatch', exports.gridReducer, function (_a) {
    var pageSize = _a.pageSize, page = _a.page, sort = _a.sort, order = _a.order, filters = _a.filters, openedFilters = _a.openedFilters, universalFilter = _a.universalFilter, columns = _a.columns, version = _a.version;
    return ({
        pageSize: pageSize,
        page: page,
        sort: sort,
        order: order,
        filters: filters,
        openedFilters: openedFilters,
        universalFilter: universalFilter,
        columns: columns,
        openedColumnsDialog: false,
        checkedItems: [],
        dirty: true,
        version: version,
    });
}), recompose_1.withHandlers({
    setPageSize: exports.actionHandler('PAGE_SIZE'),
    setPage: exports.actionHandler('PAGE'),
    setSort: exports.actionHandler('SORT'),
    setOrder: exports.actionHandler('ORDER'),
    setColumns: exports.actionHandler('COLUMNS'),
    setShowDeleted: exports.actionHandler('SHOW_DELETED'),
    setShowDeactivated: exports.actionHandler('SHOW_DEACTIVATED'),
    moveColumn: exports.actionHandler('MOVE_COLUMN'),
    setFilters: exports.actionHandler('FILTERS'),
    setUniversalFilter: exports.actionHandler('UNIVERSAL_FILTER'),
    setFiltersOpen: exports.actionHandler('OPEN_FILTERS'),
    refresh: function (props) { return function () {
        var action = utils_1.createAction('DIRTY');
        props.dispatch(action);
    }; },
    resetSettings: function (_a) {
        var name = _a.name, dispatch = _a.dispatch;
        return function () {
            resetPersistenceProps(name);
            var action = utils_1.createAction('DIRTY');
            dispatch(action);
        };
    },
}), recompose_1.defaultProps({ stateManagerChangedPropsChecker: stateManagerChangedPropsChecker }), recompose_1.lifecycle({
    componentWillReceiveProps: function (nextProps) {
        var _this = this;
        var propsToCheck = [
            'pageSize',
            'page',
            'sort',
            'order',
            'filters',
            'universalFilter',
            'query',
            'openedFilters',
            'columns',
        ];
        var changedProps = propsToCheck.filter(function (item) {
            return nextProps.stateManagerChangedPropsChecker(_this.props, nextProps, item);
        });
        // sync new props with state
        if (changedProps.length > 0) {
            var newState = changedProps.reduce(function (acc, item) {
                var _a;
                return (__assign((_a = {}, _a[item] = nextProps[item], _a), acc));
            }, {
                dirty: true,
            });
            nextProps.dispatch(utils_1.createAction('MERGE_STATE', newState));
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.onCheckedItemsChange) {
            var checkedItems = this.props.state.checkedItems;
            if (!lodash_1.isEqual(prevProps.state.checkedItems, checkedItems)) {
                this.props.onCheckedItemsChange(checkedItems);
            }
        }
    },
}), recompose_1.flattenProp('state'));
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/utils.js
// module id = 160
// module chunks = 0